'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { SITE_LOCALES, type SiteLocale } from '@/lib/marketing/page-metadata';
import { homePath, translatedPath, writeLangCookie } from '@/lib/marketing/locale-routing';

export function LanguageSwitcher({
  locale,
  label,
  names,
}: {
  locale: SiteLocale;
  label: string;
  names: Record<SiteLocale, string>;
}) {
  const pathname = usePathname() ?? '/';

  return (
    <nav aria-label={label} className="flex gap-3">
      {SITE_LOCALES.map((l) => (
        <Link
          key={l}
          href={translatedPath(pathname, l) ?? homePath(l)}
          hrefLang={l}
          lang={l}
          onClick={() => writeLangCookie(l)}
          aria-current={l === locale ? 'true' : undefined}
          className={l === locale ? 'text-foreground font-medium' : 'hover:text-foreground transition-colors'}
        >
          {names[l]}
        </Link>
      ))}
    </nav>
  );
}
